export var gaTrackerIds = (process.env.VITE_GA_TRACKER_ID4 || '')
    .split(',')
    .filter(function (id) { return id; })
    .map(function (trackingId) { return ({ trackingId: trackingId }); });
